export class BreakdownFilter {
  'user.email': string;
  'bike.group.name': string;
  'bike.name': string;
  'bike.type' = '';
  status = '';
  element = '';
  bkdCreationDate: Date;
  executionDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/models/filters/breakdown-filters.ts